import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    fetchNotesByBusiness,
    selectNotes,
} from '../features/notes/note.slice';
import { getDefaultNoteSearchCriteria } from '../service/model/note.model';

const useNotes = () => {
    const dispatch = useAppDispatch();
    const notes = useAppSelector(selectNotes);

    const getNotes = async () => {
        await dispatch(fetchNotesByBusiness(getDefaultNoteSearchCriteria()));
    };

    useEffect(() => {
        // if (notes.length === 0) {
            getNotes();
        // }
    }, []);

    return [notes];
};

export default useNotes;
